export default __webpack_public_path__ + "static/media/clay.875022e7.jpg";